module.exports = __webpack_public_path__ + "static/media/101-northern-cyprus.83e3edb7.svg";